import { render, staticRenderFns } from "./SecaoCnae.vue?vue&type=template&id=3c3020e7&"
import script from "./SecaoCnae.vue?vue&type=script&lang=js&"
export * from "./SecaoCnae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports